import React from 'react';
import { HeartIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="mt-24 mb-8" data-id="element-71">
      <div className="border-t-2 border-gray-200 dark:border-[#2A3F5F] pt-12" data-id="element-72">
        <div className="text-center" data-id="element-73">
          <p className="text-xl font-semibold italic text-[#1A2332] dark:text-white mb-10" data-id="element-74">
            "Because everything rises and falls on leadership."
          </p>
          <div className="bg-gradient-to-r from-[#1A2332] to-[#2A3F5F] text-white py-8 px-10 rounded-2xl inline-block shadow-2xl hover:shadow-3xl transition-shadow duration-300" data-id="element-75">
            <div className="flex items-center justify-center gap-8" data-id="element-76">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wZa7kZYb9BWgHFXMEGWTkQ/Heliona-Mascot.webp" alt="Heliona Mascot" className="h-48 w-auto" data-id="element-77" />
              <div className="flex items-center" data-id="element-78">
                <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-[#7FE5A8] to-[#5FD88F] flex items-center justify-center mr-5 shadow-lg flex-shrink-0" data-id="element-79">
                  <HeartIcon className="h-6 w-6 text-[#1A2332]" data-id="element-80" />
                </div>
                <div className="text-left max-w-xl" data-id="element-81">
                  <p className="font-semibold text-sm text-[#7FE5A8] mb-2 tracking-wide" data-id="element-82">
                    OUR GOAL
                  </p>
                  <p className="text-base leading-relaxed" data-id="element-83">
                    To make Heliona the operating system for leadership
                    well-being, empowering people leaders to thrive and
                    organizations to grow.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};